<template>
  <div class="md-layout text-center">
    <div id="firebaseui-auth-container"></div>
  </div>
</template>
<script>
//firebase
// import * as firebase from "firebase";
import * as firebaseui from "firebaseui";
import { firebaseApp } from "../../../firebase/init";

// import firebase from "firebase";
import { LoginCard } from "@/components";
export default {
  components: {
    LoginCard
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null
    };
  },
  mounted() {
    // The start method will wait until the DOM is loaded.
    let uiConfig = {
      signInSuccessUrl: "/",
      signInFlow: "popup",
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        {
          // Google provider must be enabled in Firebase Console to support one-tap
          // sign-up.
          provider: firebaseApp.auth.GoogleAuthProvider.PROVIDER_ID,
          // Required to enable this provider in one-tap sign-up.
          authMethod: "https://accounts.google.com",
          // Required to enable ID token credentials for this provider.
          // This can be obtained from the Credentials page of the Google APIs
          // console.
          clientId:
            "911992056725-uno0u77p6vc770gnv30jmr9t7bl6hhk8.apps.googleusercontent.com",

          customParameters: { hd: "una.cl" }
        }
      ],

      // credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO,
      // tosUrl and privacyPolicyUrl accept either url string or a callback
      // function.
      // Terms of service url/callback.
      tosUrl: "/terms",
      // Privacy policy url/callback.
      privacyPolicyUrl: function() {
        window.location.assign("/policy");
      }
    };

    // Initialize the FirebaseUI Widget using Firebase.
    if (ui) {
      ui.delete();
    }
    let ui = new firebaseui.auth.AuthUI(firebaseApp.auth());

    ui.start("#firebaseui-auth-container", uiConfig);
  }
};
</script>

<style>
</style>
